export default __webpack_public_path__ + "954b0f6b839ae95ce2f2abc8fdc9d854.png";